import { actions as commonActions, actionTypes as commonActionTypes } from "@tailormed/common-client/store/action";

const Types = {
  LOGIN_ACTION: "LOGIN_ACTION",
  SET_USER: "SET_USER",
  SET_NETWORK_ACTION: "SET_NETWORK_ACTION",
  ADD_PATIENT_ACTION: "ADD_PATIENT_ACTION",
  PATIENT_AUTOMATE_AFTER_CREATE_ACTION: "PATIENT_AUTOMATE_AFTER_CREATE_ACTION",
  SET_PATIENTS: "SET_PATIENTS",
  EDIT_PATIENTS: "EDIT_PATIENTS",
  SET_PATIENT_ACTION: "SET_PATIENT_ACTION",
  CLEAR_SEARCHED_PATIENTS: "CLEAR_SEARCHED_PATIENTS",
  SET_PATIENT_CYCLES: "SET_PATIENT_CYCLES",
  CLEAR_PATIENT: "CLEAR_PATIENT",
  SET_UNITES: "SET_UNITES",
  SET_ASSIGNEES: "SET_ASSIGNEES",
  SET_USERS: "SET_USERS",
  SET_ENVIRONMENT: "SET_ENVIRONMENT",
  SET_PATIENT_TABLE_COLUMNS: "SET_PATIENT_TABLE_COLUMNS",
  EDIT_CURRENT_ORDER: "EDIT_CURRENT_ORDER",
  EDIT_CURRENT_ORDER_ACTION: "EDIT_CURRENT_ORDER_ACTION",
  CHANGE_CURRENT_ORDER_ACTION: "CHANGE_CURRENT_ORDER_ACTION",
  SET_NEXT_CYCLE_ACTION: "SET_NEXT_CYCLE_ACTION",
  BULK_CHANGE_ACTION: "BULK_CHANGE_ACTION",
  ADD_PATIENT_CYCLE_ACTION: "ADD_PATIENT_CYCLE_ACTION",
  ADD_PATIENT_CYCLE: "ADD_PATIENT_CYCLE",
  DELETE_PATIENT_CYCLE_ACTION: "DELETE_PATIENT_CYCLE_ACTION",
  DELETE_PATIENT_CYCLE: "DELETE_PATIENT_CYCLE",
  SET_PATIENT_NOTES: "SET_PATIENT_NOTES",
  ADD_PATIENT_NOTES: "ADD_PATIENT_NOTES",
  UPDATE_PATIENT_NOTES: "UPDATE_PATIENT_NOTES",
  EDIT_PATIENT_NOTE_ACTION: "EDIT_PATIENT_NOTE_ACTION",
  DELETE_PATIENT_NOTE_ACTION: "DELETE_PATIENT_NOTE_ACTION",
  DELETE_PATIENT_NOTE: "DELETE_PATIENT_NOTE",
  ADD_PATIENT_NOTE_ACTION: "ADD_PATIENT_NOTE_ACTION",
  SET_PATIENT_ATTACHMENTS: "SET_PATIENT_ATTACHMENTS",
  ADD_PATIENT_ATTACHMENT_ACTION: "ADD_PATIENT_ATTACHMENT_ACTION",
  DELETE_PATIENT_ATTACHMENT_ACTION: "DELETE_PATIENT_ATTACHMENT_ACTION",
  DELETE_PATIENT_ATTACHMENT: "DELETE_PATIENT_ATTACHMENT",
  SET_PATIENT_TASKS: "SET_PATIENT_TASKS",
  ADD_PATIENT_TASK_ACTION: "ADD_PATIENT_TASK_ACTION",
  ADD_PATIENT_TASKS: "ADD_PATIENT_TASKS",
  DELETE_PATIENT_TASK_ACTION: "DELETE_PATIENT_TASK_ACTION",
  DELETE_PATIENT_TASKS: "DELETE_PATIENT_TASKS",
  EDIT_PATIENT_TASK_ACTION: "EDIT_PATIENT_TASK",
  UPDATE_PATIENT_TASKS: "UPDATE_PATIENT_TASKS",
  SET_PHARMACY_PATIENT_ACTION: "SET_PHARMACY_PATIENT_ACTION",
  GET_TRACKING_ACTION: "GET_TRACKING_ACTION",
  SET_TRACKING: "GET_TRACKING",
  SEND_SUPPORT_TICKET: "SEND_SUPPORT_TICKET",
  SET_FILTERS: "SET_FILTERS",
  SET_FILTERS_ACTION: "SET_FILTERS_ACTION",
  SET_SETTINGS: "SET_SETTINGS",
  SEARCH_PATIENTS_ACTION: "SEARCH_PATIENTS_ACTION",
  SET_SEARCHED_PATIENTS: "SET_SEARCHED_PATIENTS",
  SELECT_SEARCHED_PATIENT: "SELECT_SEARCHED_PATIENT",
  SET_SEARCHED_PATIENT: "SET_SEARCHED_PATIENT",
  SET_SHOW_PATIENT_MODAL: "SET_SHOW_PATIENT_MODAL",
  SET_ID_PATIENT_MODAL: "SET_ID_PATIENT_MODAL",
  CLONE_PHARMACY_PATIENT_ACTION: "CLONE_PHARMACY_PATIENT_ACTION",
  SET_USER_EMAIL_CONFIGURATION: "SET_USER_EMAIL_CONFIGURATION",
  SET_USER_EMAIL_CONFIGURATION_ACTION: "SET_USER_EMAIL_CONFIGURATION_ACTION",
  SET_NOTIFICATION_PREFERENCES: "SET_NOTIFICATION_PREFERENCES",
  UPDATE_NOTIFICATION_PREFERENCES_ACTION: "UPDATE_NOTIFICATION_PREFERENCES_ACTION",
  SET_IDP_CONFIG: "SET_IDP_CONFIG",
  SET_USER_GROUPS: "SET_USER_GROUPS",
  SET_USER_GROUPS_WITH_USERS: "SET_USER_GROUPS_WITH_USERS",
  SET_OKTA_CONFIG: "SET_OKTA_CONFIG",
  SET_CALENDAR_VIEW_TYPE: "SET_CALENDAR_VIEW_TYPE",
  GET_PATIENT_ORDER: "GET_PATIENT_ORDER",
  SET_CURRENT_CYCLE: "SET_CURRENT_CYCLE",
  GET_AP_SPONSORS: "GET_AP_SPONSORS",
  SET_EDIT_CYCLE_MODE: "SET_EDIT_CYCLE_MODE",
  GET_PATIENT_ORDER_BY_ID: "GET_PATIENT_ORDER_BY_ID",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_SEARCH_RESULT_CURRENT_PAGE: "SET_SEARCH_RESULT_CURRENT_PAGE",
  SET_TOTAL_PATIENTS: "SET_TOTAL_PATIENTS",
  SET_SEARCHED_TEXT: "SET_SEARCHED_TEXT",
  SEARCH_PATIENTS_TEXT_FILTERS_ACTION: "SEARCH_PATIENTS_TEXT_FILTERS_ACTION",
  SET_SORTING: "SET_SORTING",
  SET_CYCLE_FLASH_ENABLED: "SET_CYCLE_FLASH_ENABLED",
  SET_ORDERS_TABLE_SEARCHED_TEXT: "SET_ORDERS_TABLE_SEARCHED_TEXT",
  SET_VIEW_TYPE: "SET_VIEW_TYPE",
  SET_IS_LOADING_ENABLED: "SET_IS_LOADING_ENABLED",
  SET_IS_FILTER_LIST_VISIABLE: "SET_IS_FILTER_LIST_VISIABLE",
  SET_FILTER_LIST: "SET_FILTER_LIST",
  CREATE_FILTER_LIST_ACTION: "CREATE_FILTER_LIST_ACTION",
  SET_LIST_NAME_QUERY_ACTION: "SET_LIST_NAME_QUERY_ACTION",
  SET_SAVED_LIST_SORT_BY_ACTION: "SET_SAVED_LIST_SORT_BY_ACTION",
  SET_SAVED_LIST_ORDER_BY_ACTION: "SET_SAVED_LIST_ORDER_BY_ACTION",
  SEARCH_SAVED_LIST_ACTION: "SEARCH_SAVED_LIST_ACTION",
  SET_TABLE_DATA: "SET_TABLE_DATA",
  SET_SAVED_LIST_TABLE_COLUMNS: "SET_SAVED_LIST_TABLE_COLUMNS",
  SET_SAVED_LISTS_TABLE_RECORD_DATA: "SET_SAVED_LISTS_TABLE_RECORD_DATA",
  SET_SELECTED_FILTER_LIST_TYPE: "SET_SELECTED_FILTER_LIST_TYPE",
  SET_FORM_POPUPS: "SET_FORM_POPUPS",
  UPDATE_FILTER_LIST_ACTION: "UPDATE_FILTER_LIST_ACTION",
  UPDATE_FILTER_LIST_STATUSES: "UPDATE_FILTER_LIST_STATUSES",
  UPDATE_SAVED_FILTER_VIEW_PARAMETERS: "UPDATE_SAVED_FILTER_VIEW_PARAMETERS",
  SEARCH_SAVED_LIST_BY_ID: "SEARCH_SAVED_LIST_BY_ID",
  MARK_SAVED_FILTER_AS_CHANGED: "MARK_SAVED_FILTER_AS_CHANGED",
  CLEAR_SAVED_LIST_RELATED_DATA_ACTION: "CLEAR_SAVED_LIST_RELATED_DATA_ACTION",
  CLEAR_SORTER: "CLEAR_SORTER",
  CLEAR_FILTERS_INPUTS: "CLEAR_FILTERS_INPUTS",
  SET_SAVED_TABLE_SELECTED_PAGE: "SET_SAVED_TABLE_SELECTED_PAGE",
  SET_SAVED_LIST_VIEW_TYPE: "SET_SAVED_LIST_VIEW_TYPE",
  SET_SAVED_LIST_SELECTED: "SET_SAVED_LIST_SELECTED",
  INIT_SAVED_LIST: "INIT_SAVED_LIST",
  SET_CALENDAR_VIEW_TYPE_DATE: "SET_CALENDAR_VIEW_TYPE_DATE",
  SET_CAN_VIEW_OR_DOWNLOAD_PATIENT_ATTACHMENT: "SET_CAN_VIEW_OR_DOWNLOAD_PATIENT_ATTACHMENT",
  SET_MULTIPLES: "SET_MULTIPLES",
  SET_CSV_PATIENT_REPORT_DATA: "SET_CSV_PATIENT_REPORT_DATA",
  SET_CYCLE_ADMIN_DATE_FILTER: "SET_CYCLE_ADMIN_DATE_FILTER",
  REFRESH_CYCLES_ACTION: "REFRESH_CYCLES_ACTION",
  SET_IS_ADDING_PATIENT_CYCLE: "SET_IS_ADDING_PATIENT_CYCLE",
  SET_SELECTED_ORDER: "SET_SELECTED_ORDER",
  CLEAR_SELECTED_ORDER: "CLEAR_SELECTED_ORDER",
  SWITCH_ORDER_ACTION: "SWITCH_ORDER_ACTION",
  FETCH_AP_SPONSORS_ACTION: "FETCH_AP_SPONSORS_ACTION",
  ...commonActionTypes
};

const loginAction = (username, password) => ({
  type: Types.LOGIN_ACTION,
  username,
  password
});

const setUser = (user) => ({
  type: Types.SET_USER,
  user
});

const setNetworkAction = (actionType, isFetching, msg = "", code = undefined) => ({
  type: Types.SET_NETWORK_ACTION,
  actionType,
  isFetching,
  msg,
  code
});

const setEnvironment = (environment) => ({
  type: Types.SET_ENVIRONMENT,
  environment
});

const editPatients = (patients) => ({
  type: Types.EDIT_PATIENTS,
  patients
});

const addPatientAction = (patient) => ({
  type: Types.ADD_PATIENT_ACTION,
  patient
});

const patientAutomateAfterCreateAction = (patientId) => ({
  type: Types.PATIENT_AUTOMATE_AFTER_CREATE_ACTION,
  patientId
});

const setPatients = (patients) => ({
  type: Types.SET_PATIENTS,
  patients
});

const setPatientAction = (pharmacyPatient, patientId, orderId) => ({
  type: Types.SET_PATIENT_ACTION,
  pharmacyPatient,
  patientId,
  orderId
});

const getPatientOrderAction = (pharmacyPatient) => ({
  type: Types.GET_PATIENT_ORDER,
  pharmacyPatient
});

const getPatientOrderByIdAction = (orderId) => ({
  type: Types.GET_PATIENT_ORDER_BY_ID,
  orderId
});

const setCanViewOrDownloadPatientAttachmentsAction = (canViewOrDownloadPatientAttachments) => ({
  type: Types.SET_CAN_VIEW_OR_DOWNLOAD_PATIENT_ATTACHMENT,
  canViewOrDownloadPatientAttachments
});

const setCSVPatientReportAction = (data, isReadyToDownload) => ({
  type: Types.SET_CSV_PATIENT_REPORT_DATA,
  csvPatientReportData: {
    data,
    isReadyToDownload
  }
});

const setCurrentCycle = (currentCycle) => ({
  type: Types.SET_CURRENT_CYCLE,
  currentCycle
});

const setPatientCycles = (patientCycles, filteredPatientCycles) => ({
  type: Types.SET_PATIENT_CYCLES,
  patientCycles,
  filteredPatientCycles
});

const setUserGroups = (userGroups) => ({
  type: Types.SET_USER_GROUPS,
  userGroups
});

const setUserGroupsWithUsers = (userGroupsWithUsers) => ({
  type: Types.SET_USER_GROUPS_WITH_USERS,
  userGroupsWithUsers
});

const addPatientCycleAction = (newCycle, setNextCycle = false) => ({
  type: Types.ADD_PATIENT_CYCLE_ACTION,
  newCycle,
  setNextCycle
});

const deletePatientCycleAction = (id, pharmacyPatient) => ({
  type: Types.DELETE_PATIENT_CYCLE_ACTION,
  id,
  pharmacyPatient
});

const deletePatientCycle = (id) => ({
  type: Types.DELETE_PATIENT_CYCLE,
  id
});

const addPatientAttachmentsAction = (patientId, pharmacyPatient, file, orderIndex = null) => ({
  type: Types.ADD_PATIENT_ATTACHMENT_ACTION,
  patientId,
  pharmacyPatient,
  file,
  orderIndex
});

const deletePatientAttachmentsAction = (id, attachmentUniqueId, pharmacyPatient) => ({
  type: Types.DELETE_PATIENT_ATTACHMENT_ACTION,
  id,
  attachmentUniqueId,
  pharmacyPatient
});

const deletePatientAttachments = (id) => ({
  type: Types.DELETE_PATIENT_ATTACHMENT,
  id
});

const setPatientAttachments = (pharmacyPatient, attachments) => ({
  type: Types.SET_PATIENT_ATTACHMENTS,
  pharmacyPatient,
  attachments
});

const setPatientTasks = (tasks) => ({
  type: Types.SET_PATIENT_TASKS,
  tasks
});

const addPatientTaskAction = (task, pharmacyPatient) => ({
  type: Types.ADD_PATIENT_TASK_ACTION,
  task,
  pharmacyPatient
});

const addPatientTasks = (tasks) => ({
  type: Types.ADD_PATIENT_TASKS,
  tasks
});

const editPatientTaskAction = (task, pharmacyPatient) => ({
  type: Types.EDIT_PATIENT_TASK_ACTION,
  task,
  pharmacyPatient
});

const updatePatientTasks = (tasks) => ({
  type: Types.UPDATE_PATIENT_TASKS,
  tasks
});

const deletePatientTaskAction = (task, pharmacyPatient) => ({
  type: Types.DELETE_PATIENT_TASK_ACTION,
  task,
  pharmacyPatient
});

const deletePatientTasks = (tasks) => ({
  type: Types.DELETE_PATIENT_TASKS,
  tasks
});

const setPatientNotes = (pharmacyPatient, notes) => ({
  type: Types.SET_PATIENT_NOTES,
  pharmacyPatient,
  notes
});

const addPatientNotes = (notes) => ({
  type: Types.ADD_PATIENT_NOTES,
  notes
});

const updatePatientNotes = (notes) => ({
  type: Types.UPDATE_PATIENT_NOTES,
  notes
});

const editPatientNoteAction = (noteId, note, patientId, pharmacyPatient) => ({
  type: Types.EDIT_PATIENT_NOTE_ACTION,
  noteId,
  note,
  patientId,
  pharmacyPatient
});
const deletePatientNote = (noteId) => ({
  type: Types.DELETE_PATIENT_NOTE,
  noteId
});

const deletePatientNoteAction = (patientId, noteId, pharmacyPatient) => ({
  type: Types.DELETE_PATIENT_NOTE_ACTION,
  patientId,
  noteId,
  pharmacyPatient
});

const addPatientNoteAction = (patientId, note, orderIndex, pharmacyPatient) => ({
  type: Types.ADD_PATIENT_NOTE_ACTION,
  patientId,
  note,
  orderIndex,
  pharmacyPatient
});

const addPatientCycle = (pharmacyPatient) => ({
  type: Types.ADD_PATIENT_CYCLE,
  pharmacyPatient
});

const clearPatient = () => ({
  type: Types.CLEAR_PATIENT
});

const editCurrentOrderAction = (currentOrder, pharmacyPatient = null) => ({
  type: Types.EDIT_CURRENT_ORDER_ACTION,
  currentOrder,
  pharmacyPatient
});

const changeCurrentOrderAction = (pharmacyPatient, currentOrder) => ({
  type: Types.CHANGE_CURRENT_ORDER_ACTION,
  pharmacyPatient,
  currentOrder
});

const editCurrentOrder = (currentOrder) => ({
  type: Types.EDIT_CURRENT_ORDER,
  currentOrder
});

const setNextCycleAction = (pharmacyPatient, currentAdministrationDate, currentOrderIndex) => ({
  type: Types.SET_NEXT_CYCLE_ACTION,
  pharmacyPatient,
  currentAdministrationDate,
  currentOrderIndex
});

const setUnites = (units) => ({
  type: Types.SET_UNITES,
  units
});

const setAssignees = (assignees) => ({
  type: Types.SET_ASSIGNEES,
  assignees
});

const setUsers = (users) => ({
  type: Types.SET_USERS,
  users
});

const setPatientTableColumns = (patientTableColumns) => ({
  type: Types.SET_PATIENT_TABLE_COLUMNS,
  patientTableColumns
});

const bulkChangeAction = (pharmacyPatient, orders, stopEditingCycleMode = false, noPagination) => ({
  type: Types.BULK_CHANGE_ACTION,
  pharmacyPatient,
  orders,
  stopEditingCycleMode,
  noPagination
});

const setPharmacyPatientAction = (pharmacyPatient) => ({
  type: Types.SET_PHARMACY_PATIENT_ACTION,
  pharmacyPatient
});

const getTrackingAction = (carrier, trackingNumber) => ({
  type: Types.GET_TRACKING_ACTION,
  carrier,
  trackingNumber
});

const setTracking = (tracking) => ({
  type: Types.SET_TRACKING,
  tracking
});
const sentSupportTicketAction = (subject, comment, patient, user) => ({
  type: Types.SEND_SUPPORT_TICKET,
  subject,
  comment,
  patient,
  user
});

const setFilters = (filters) => ({
  type: Types.SET_FILTERS,
  filters
});

const setKeepEditingCycleMode = (keepEditingCycleMode) => ({
  type: Types.SET_EDIT_CYCLE_MODE,
  keepEditingCycleMode
});

const setFiltersAction = (filters, apiName, page, sorting) => ({
  type: Types.SET_FILTERS_ACTION,
  filters,
  apiName,
  page,
  sorting
});

const setSettings = (settings) => ({
  type: Types.SET_SETTINGS,
  settings
});

const searchPatientsAction = (page, text, searchBy) => ({
  type: Types.SEARCH_PATIENTS_ACTION,
  page,
  text,
  searchBy
});

const setSearchedPatients = ({ patients, total, sorting }) => ({
  type: Types.SET_SEARCHED_PATIENTS,
  patients,
  total,
  sorting
});

const setSearchedPatient = (patient) => ({
  type: Types.SET_SEARCHED_PATIENT,
  patient
});

const setShowPatientModal = (show, tab = 0) => ({
  type: Types.SET_SHOW_PATIENT_MODAL,
  show,
  tab
});

const setIdPatientModal = (idPatientModal) => ({
  type: Types.SET_ID_PATIENT_MODAL,
  idPatientModal
});

const setCalendarViewType = (calendarViewType) => ({
  type: Types.SET_CALENDAR_VIEW_TYPE,
  calendarViewType
});

const clearSearchedPatients = () => ({
  type: Types.CLEAR_SEARCHED_PATIENTS
});

const clonePharmacyPatientAction = (pharmacyPatientId) => ({
  type: Types.CLONE_PHARMACY_PATIENT_ACTION,
  pharmacyPatientId
});

const setUserEmailConfigurationAction = ({ triggerName, active }) => ({
  type: Types.SET_USER_EMAIL_CONFIGURATION_ACTION,
  emailConfiguration: { triggerName, active }
});

const setUserEmailConfiguration = (emailConfiguration) => ({
  type: Types.SET_USER_EMAIL_CONFIGURATION,
  emailConfiguration
});

const setNotificationPreferences = (notificationPreferences) => ({
  type: Types.SET_NOTIFICATION_PREFERENCES,
  notificationPreferences
});

const updateNotificationPreferencesAction = (preferenceType, targetId, notificationType, isEnabled) => ({
  type: Types.UPDATE_NOTIFICATION_PREFERENCES_ACTION,
  preferenceType,
  targetId,
  notificationType,
  isEnabled
});

const setIDPConfig = (idpConfig) => ({
  type: Types.SET_IDP_CONFIG,
  idpConfig
});

const setOktaConfig = (oktaClientId) => ({
  type: Types.SET_OKTA_CONFIG,
  oktaClientId
});

const APSponsors = (data) => ({
  type: Types.GET_AP_SPONSORS,
  data
});

const setTotalPatients = (totalPatients) => ({
  type: Types.SET_TOTAL_PATIENTS,
  totalPatients
});

const setCurrentPage = (currentPage) => ({
  type: Types.SET_CURRENT_PAGE,
  currentPage
});

const setSearchResultCurrentPage = (searchResultCurrentPage) => ({
  type: Types.SET_SEARCH_RESULT_CURRENT_PAGE,
  searchResultCurrentPage
});

const setSearchText = (searchText) => ({
  type: Types.SET_SEARCHED_TEXT,
  searchText
});

const setOrdersTableSearchText = (ordersTableSearchText) => ({
  type: Types.SET_ORDERS_TABLE_SEARCHED_TEXT,
  ordersTableSearchText
});

const searchPatientTextFiltersAction = (page, text, searchBy, filters) => ({
  type: Types.SEARCH_PATIENTS_TEXT_FILTERS_ACTION,
  page,
  text,
  searchBy,
  filters
});

const setSorting = (sorting) => ({
  type: Types.SET_SORTING,
  sorting
});

const setEnableCycleFlash = (enableFlash) => ({
  type: Types.SET_CYCLE_FLASH_ENABLED,
  enableFlash
});

const setViewType = (viewType) => ({
  type: Types.SET_VIEW_TYPE,
  viewType
});

const setIsLoadingEnabled = (isLoadingEnabled) => ({
  type: Types.SET_IS_LOADING_ENABLED,
  isLoadingEnabled
});

const setIsAddingPatientCycle = (isAddingPatientCycle) => ({
  type: Types.SET_IS_ADDING_PATIENT_CYCLE,
  isAddingPatientCycle
});

const setSelectedOrder = (orderId) => ({
  type: Types.SET_SELECTED_ORDER,
  orderId
});

const clearSelectedOrder = () => ({
  type: Types.CLEAR_SELECTED_ORDER
});

const switchOrderAction = (orderId, pharmacyPatient) => ({
  type: Types.SWITCH_ORDER_ACTION,
  orderId,
  pharmacyPatient
});

const fetchAPSponsorsAction = () => ({
  type: Types.FETCH_AP_SPONSORS_ACTION
});

const setFilterListFormVisiable = (isVisiable) => ({
  type: Types.SET_IS_FILTER_LIST_VISIABLE,
  isVisiable
});

const setFilterList = (filterList) => ({
  type: Types.SET_FILTER_LIST,
  filterList
});

const createFilterListAction = (data) => ({
  type: Types.CREATE_FILTER_LIST_ACTION,
  data
});

const setSavedListTableColumns = (savedListColumns) => ({
  type: Types.SET_SAVED_LIST_TABLE_COLUMNS,
  savedListColumns
});

const updateSavedListOrderBy = (columnName) => ({
  type: Types.SET_SAVED_LIST_ORDER_BY_ACTION,
  orderBy: columnName
});

const updateSavedListSortBy = (sortByDirection) => ({
  type: Types.SET_SAVED_LIST_SORT_BY_ACTION,
  sortBy: sortByDirection
});

const setListNameQueryAction = (query) => ({
  type: Types.SET_LIST_NAME_QUERY_ACTION,
  query
});

const searchSavedListAction = (page) => ({
  type: Types.SEARCH_SAVED_LIST_ACTION,
  page
});

const setTableData = (tableData, selectedPage, sorter = {}) => ({
  type: Types.SET_TABLE_DATA,
  tableData,
  selectedPage,
  sorter
});

const setSavedListSelectedPage = (selectedPage) => ({
  type: Types.SET_SAVED_TABLE_SELECTED_PAGE,
  selectedPage
});

const setSavedListsTableRecordData = (recordData) => ({
  type: Types.SET_SAVED_LISTS_TABLE_RECORD_DATA,
  recordData
});

const setSelectedFilterListType = (listType) => ({
  type: Types.SET_SELECTED_FILTER_LIST_TYPE,
  listType
});

const setFormPopups = (visible, isDuplicateMode = false) => ({
  type: Types.SET_FORM_POPUPS,
  visible,
  isDuplicateMode
});

const updateFilterListAction = (data, filterListId) => ({
  type: Types.UPDATE_FILTER_LIST_ACTION,
  data,
  filterListId
});

const updateFilterListStatuses = (filterListID, canModify, showDiscardModal) => ({
  type: Types.UPDATE_FILTER_LIST_STATUSES,
  filterListID,
  canModify,
  showDiscardModal
});

const updateSavedFilterViewParameters = (filterListID, selectedPage, sorter) => ({
  type: Types.UPDATE_SAVED_FILTER_VIEW_PARAMETERS,
  filterListID,
  selectedPage,
  sorter
});

const searchSavedListByIdAction = (data) => ({
  type: Types.SEARCH_SAVED_LIST_BY_ID,
  data
});

const markSavedFilterAsChanged = (filterListID, filterListStatus) => ({
  type: Types.MARK_SAVED_FILTER_AS_CHANGED,
  filterListID,
  filterListStatus
});

const clearSavedListRelatedDataAction = () => ({
  type: Types.CLEAR_SAVED_LIST_RELATED_DATA_ACTION
});

const clearSorterAction = (view) => ({
  type: Types.CLEAR_SORTER,
  view
});

const clearFiltersInputs = () => ({
  type: Types.CLEAR_FILTERS_INPUTS
});

const initSavedListAction = () => ({
  type: Types.INIT_SAVED_LIST
});

const setSavedListViewType = (savedListViewType) => ({
  type: Types.SET_SAVED_LIST_VIEW_TYPE,
  savedListViewType
});

const setCalendarOrderDateFilter = (calendarOrderDateFilter) => ({
  type: Types.SET_CALENDAR_VIEW_TYPE_DATE,
  calendarOrderDateFilter
});

const setMultiplesFilter = (multiples) => ({
  type: Types.SET_MULTIPLES,
  multiples
});

const setCycleAdminDateFilter = (cycleAdminDateFilter) => ({
  type: Types.SET_CYCLE_ADMIN_DATE_FILTER,
  cycleAdminDateFilter
});

const refreshCyclesAction = (pharmacyPatient) => ({
  type: Types.REFRESH_CYCLES_ACTION,
  pharmacyPatient
});

export default {
  loginAction,
  setUser,
  setNetworkAction,
  setEnvironment,
  addPatientAction,
  patientAutomateAfterCreateAction,
  setPatients,
  setPatientCycles,
  addPatientCycleAction,
  addPatientCycle,
  deletePatientCycleAction,
  deletePatientCycle,
  setPatientNotes,
  setPatientAttachments,
  addPatientAttachmentsAction,
  deletePatientAttachmentsAction,
  deletePatientAttachments,
  setPatientTasks,
  addPatientTaskAction,
  addPatientTasks,
  editPatientTaskAction,
  clearSearchedPatients,
  updatePatientTasks,
  deletePatientTaskAction,
  deletePatientTasks,
  addPatientNotes,
  updatePatientNotes,
  editPatientNoteAction,
  deletePatientNote,
  deletePatientNoteAction,
  addPatientNoteAction,
  clearPatient,
  setPatientAction,
  editCurrentOrderAction,
  changeCurrentOrderAction,
  editCurrentOrder,
  setNextCycleAction,
  editPatients,
  setUnites,
  setAssignees,
  setUsers,
  setPatientTableColumns,
  bulkChangeAction,
  setPharmacyPatientAction,
  getTrackingAction,
  setTracking,
  sentSupportTicketAction,
  setFilters,
  setFiltersAction,
  setKeepEditingCycleMode,
  setSettings,
  setUserGroups,
  setUserGroupsWithUsers,
  searchPatientsAction,
  setSearchedPatients,
  setSearchedPatient,
  setShowPatientModal,
  setIdPatientModal,
  clonePharmacyPatientAction,
  setUserEmailConfigurationAction,
  setUserEmailConfiguration,
  setNotificationPreferences,
  updateNotificationPreferencesAction,
  setIDPConfig,
  setOktaConfig,
  setCalendarViewType,
  getPatientOrderAction,
  setCurrentCycle,
  getPatientOrderByIdAction,
  APSponsors,
  setSearchText,
  setEnableCycleFlash,
  Types,
  setCurrentPage,
  setTotalPatients,
  searchPatientTextFiltersAction,
  setSorting,
  setOrdersTableSearchText,
  setSearchResultCurrentPage,
  setViewType,
  setIsLoadingEnabled,
  setFilterListFormVisiable,
  setCanViewOrDownloadPatientAttachmentsAction,
  setCSVPatientReportAction,
  setFilterList,
  createFilterListAction,
  updateSavedListOrderBy,
  updateSavedListSortBy,
  setListNameQueryAction,
  searchSavedListAction,
  setTableData,
  setSavedListTableColumns,
  setSavedListsTableRecordData,
  setSelectedFilterListType,
  setFormPopups,
  updateFilterListAction,
  updateFilterListStatuses,
  updateSavedFilterViewParameters,
  searchSavedListByIdAction,
  markSavedFilterAsChanged,
  clearSavedListRelatedDataAction,
  clearSorterAction,
  clearFiltersInputs,
  setSavedListSelectedPage,
  initSavedListAction,
  setSavedListViewType,
  setCalendarOrderDateFilter,
  setMultiplesFilter,
  setCycleAdminDateFilter,
  refreshCyclesAction,
  setIsAddingPatientCycle,
  setSelectedOrder,
  clearSelectedOrder,
  switchOrderAction,
  fetchAPSponsorsAction,
  ...commonActions
};
